const hasPermission = (state, getters, rootState, rootGetters) => permissionIds => {
    const allPermissions = rootGetters['auth/getAppPermissions']('AMNT');

    if (!allPermissions) {
        return false;
    }

    const community = rootGetters['auth/community'];

    const communityPermissions = allPermissions.find(({ communityId }) => {
        return !community && !communityId ? true : community.id === communityId;
    });

    if (!communityPermissions) {
        return false;
    }

    const permissionSet = new Set(communityPermissions.permissions.map(({ id }) => id));

    return (Array.isArray(permissionIds) ? permissionIds : [permissionIds]).some(id => permissionSet.has(id));
};

export default {
    hasPermission,
};
